import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Problem, WhatWeDo } from "@/components/Problem";
import { Solutions, FinancialSoftware } from "@/components/Solutions";
import { Process, StagedImplementation } from "@/components/Process";
import { DashboardMockup } from "@/components/DashboardMockup";
import { Industries, Capacity, CustomDevelopment } from "@/components/Industries";
import { About, Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-offwhite" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <WhatWeDo />
        <Solutions />
        <FinancialSoftware />
        <Process />
        <StagedImplementation />
        <DashboardMockup />
        <Industries />
        <Capacity />
        <CustomDevelopment />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
